class Screen {
  constructor() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this._listeners = new Set();
    this._debounceTimer = null;

    window.addEventListener('resize', this._onResize.bind(this));
  }

  _onResize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;

    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => {
      this._listeners.forEach((fn) => fn(this.width, this.height));
    }, 150);
  }

  onResize(fn) {
    this._listeners.add(fn);
  }

  offResize(fn) {
    this._listeners.delete(fn);
  }
}

export default new Screen();
